import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FrameComponent } from 'src/app/components/Core/frame/frame.component';
import { SimulationsComponent } from 'src/app/components/Core/simulations/simulations.component';
import { Error404Component } from 'src/app/components/error404/error404.component';
import { HomeComponent } from 'src/app/components/home/home.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'home/:subject', component: SimulationsComponent },
  {
    path: 'simulation/:simUrl', component: FrameComponent,
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  // { path: '**', component: Error404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
